import { EnableTanstackDevToolsInProd, FeatureFlags, ResetEnvironment, SyncLangsteRoutes, WebsocketDebugging } from "@/features/beheer";
import { PublishDossierUpdate } from "@/features/beheer/components/publish-dossier-update.tsx";
import { UploadRijtijden, UploadRoutes } from "@/features/tvv";
import { useGetVersion } from "@/infrastructure/rest";
import {
    Card,
    CardContent,
    CardHeader,
    Container,
    MessageBar,
    Separator,
    Tabs,
    TabsContent,
    TabsList,
    TabsTrigger,
} from "@/shared/components";
import { isNotProduction } from "@/shared/utils/env-utils";
import { useState } from "react";

type BeheerTab = "administratie" | "tvv" | "feature-flags" | "debugging";
export default function BeheerPage() {
    const { data: currentVersion } = useGetVersion();
    const [activeTab, setActiveTab] = useState<BeheerTab>("administratie");

    return (
        <Container fluid>
            <div className="p-10">
                <div className="mb-6 flex items-center justify-between">
                    <div className="flex flex-row items-center gap-2">
                        <h1 className="text-xxl font-bold text-gray-900">Beheer SEIN</h1>
                        {currentVersion && <code>v{currentVersion}</code>}
                    </div>
                </div>
                <div className="grid gap-4">
                    <Tabs
                        className="bg-elevated-1 z-10 grid gap-0 overflow-hidden"
                        value={activeTab}
                        onValueChange={(value) => setActiveTab(value as BeheerTab)}
                    >
                        <hgroup>
                            <TabsList className="px-4">
                                <TabsTrigger value="administratie">Administratie</TabsTrigger>
                                <TabsTrigger value="tvv">TVV</TabsTrigger>
                                <TabsTrigger value="feature-flags">Feature flags</TabsTrigger>
                                <TabsTrigger value="debugging">Debugging</TabsTrigger>
                            </TabsList>
                        </hgroup>
                        <TabsContent value="administratie" className="overflow-y-auto">
                            <Card className="border-error my-2 border-2 p-4">
                                <CardHeader>
                                    <MessageBar variant="error">Pas op! Deze acties zijn uitsluitend voor administrators.</MessageBar>
                                </CardHeader>
                                <CardContent className="flex flex-col gap-4">
                                    <div className="flex flex-col gap-2">
                                        {isNotProduction() && <ResetEnvironment />}
                                        <PublishDossierUpdate />
                                    </div>
                                    <Separator orientation="horizontal" />
                                    <SyncLangsteRoutes />
                                </CardContent>
                            </Card>
                        </TabsContent>
                        <TabsContent value="tvv" className="overflow-y-auto">
                            <Card className="my-2 border-2 p-4">
                                <CardHeader>
                                    <MessageBar variant="info">Beheer TVV routes en rijtijden</MessageBar>
                                </CardHeader>
                                <CardContent className="flex flex-col gap-4">
                                    <div className="flex gap-4">
                                        <UploadRoutes />
                                        <UploadRijtijden />
                                    </div>
                                </CardContent>
                            </Card>
                        </TabsContent>
                        <TabsContent value="feature-flags" className="overflow-y-auto">
                            <Card className="my-2 border-2 p-4">
                                <CardHeader>
                                    <MessageBar variant="info">Hier kunnen feature flags aan- of uitgezet worden</MessageBar>
                                </CardHeader>
                                <CardContent className="flex flex-col gap-4">
                                    <FeatureFlags />
                                </CardContent>
                            </Card>
                        </TabsContent>
                        <TabsContent value="debugging" className="overflow-y-auto">
                            <Card className="my-2 border-2 p-4">
                                <CardHeader>
                                    <MessageBar variant="info">Tools die handig kunnen zijn bij debuggen</MessageBar>
                                </CardHeader>
                                <CardContent className="flex flex-col gap-4">
                                    <WebsocketDebugging />
                                    <Separator orientation="horizontal" />
                                    <EnableTanstackDevToolsInProd />
                                </CardContent>
                            </Card>
                        </TabsContent>
                    </Tabs>
                </div>
            </div>
        </Container>
    );
}
